import React from 'react';

function SendIcon({ className, ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        id="Round"
        d="M3.67148 20.4L21.1215 12.92C21.9315 12.57 21.9315 11.43 21.1215 11.08L3.67148 3.60002C3.01148 3.31002 2.28148 3.80002 2.28148 4.51002L2.27148 9.12002C2.27148 9.62002 2.64148 10.05 3.14148 10.11L17.2715 12L3.14148 13.88C2.64148 13.95 2.27148 14.38 2.27148 14.88L2.28148 19.49C2.28148 20.2 3.01148 20.69 3.67148 20.4Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SendIcon;
